import React, {
  useState
} from "react";

import {
  applyForGallery
} from "./GalleryApi";

export default function GalleryApply({
  user
}) {

  const [phone, setPhone] =
    useState("");

  const [about, setAbout] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  const submitApplication =
    async () => {

      if (
  !phone.trim() ||
  phone.trim().length < 10
) {

  alert(
    "Please enter a valid contact number"
  );

  return;

}

     if (
  !about.trim() ||
  about.trim().length < 20
) {

  alert(
    "Please provide at least 20 characters about yourself"
  );

  return;

}
      try {

        setLoading(true);

        const result =
          await applyForGallery({

            uid:
              user.uid,

            email:
              user.email || "",

            displayName:
              user.displayName || "",

            photoURL:
              user.photoURL || "",

            phone:
              phone.trim(),

            about:
              about.trim()

          });

        if (
          result &&
          result.success === false
        ) {

          throw new Error(
            result.message ||
            "Failed to submit application"
          );

        }

        window.scrollTo(
          0,
          0
        );

        alert(
          "Application submitted successfully. Your account is now awaiting approval."
        );
		
		window.location.replace(
  "/gallery/pending"
);

      } catch (err) {

        console.error(
          err
        );

        alert(
          err?.message ||
          "Failed to submit application"
        );

      } finally {

        setLoading(false);

      }

    };

  return (

    <div
      style={{
        minHeight:
          "100vh",
        display:
          "flex",
        justifyContent:
          "center",
        alignItems:
          "center",
        padding: 24,
        background:
          "radial-gradient(circle at top left,#60a5fa,#7c3aed,#111827)"
      }}
    >

      <div
        style={{
          width: "100%",
          maxWidth: 700,
          background:
            "rgba(255,255,255,.97)",
          borderRadius: 30,
          padding: 32,
          boxShadow:
            "0 25px 70px rgba(0,0,0,.25)"
        }}
      >

        <h1
          style={{
            textAlign:
              "center",
            marginTop: 0,
            marginBottom: 10
          }}
        >
          🎨 Become a PITICS Gallery Partner
        </h1>

        <p
          style={{
            textAlign:
              "center",
            color:
              "#6b7280",
            lineHeight: 1.7,
            marginBottom: 30
          }}
        >
          Share drawings,
          worksheets,
          coloring pages,
          educational charts
          and activities with
          students, teachers
          and parents through
          PITICS Gallery.
        </p>

        <div
          style={{
            textAlign:
              "center",
            marginBottom: 30
          }}
        >

          {user?.photoURL && (

            <img
              src={
                user.photoURL
              }
              alt=""
              style={{
                width: 110,
                height: 110,
                borderRadius:
                  "50%",
                objectFit:
                  "cover",
                border:
                  "4px solid #e5e7eb"
              }}
            />

          )}

        </div>

        <div
          style={{
            marginBottom: 18
          }}
        >

          <label>
            Full Name
          </label>

          <input
            value={
              user?.displayName ||
              ""
            }
            disabled
            style={{
              width: "100%",
              padding: 12,
              marginTop: 6,
              borderRadius: 10,
              border:
                "1px solid #d1d5db"
            }}
          />

        </div>

        <div
          style={{
            marginBottom: 18
          }}
        >

          <label>
            Email Address
          </label>

          <input
            value={
              user?.email || ""
            }
            disabled
            style={{
              width: "100%",
              padding: 12,
              marginTop: 6,
              borderRadius: 10,
              border:
                "1px solid #d1d5db"
            }}
          />

        </div>

        <div
          style={{
            marginBottom: 18
          }}
        >

          <label>
            Contact Number
          </label>

          <input
            value={phone}
            onChange={(e) =>
              setPhone(
                e.target.value
              )
            }
            placeholder="Enter your contact number"
            style={{
              width: "100%",
              padding: 12,
              marginTop: 6,
              borderRadius: 10,
              border:
                "1px solid #d1d5db"
            }}
          />

        </div>

        <div
          style={{
            marginBottom: 24
          }}
        >

          <label>
            Tell Us About Yourself
          </label>

          <textarea
            value={about}
            onChange={(e) =>
              setAbout(
                e.target.value
              )
            }
            rows={6}
            placeholder="Tell us what kind of content you would like to share with PITICS students..."
            style={{
              width: "100%",
              padding: 12,
              marginTop: 6,
              borderRadius: 10,
              border:
                "1px solid #d1d5db",
              resize:
                "vertical"
            }}
          />

        </div>

        <button
          onClick={
            submitApplication
          }
          disabled={
            loading
          }
          style={{
            width: "100%",
            padding: 16,
            border: "none",
            borderRadius: 999,
            cursor: loading
              ? "not-allowed"
              : "pointer",
            fontWeight: 800,
            fontSize: 16,
            color: "#fff",
            background:
              "linear-gradient(135deg,#2563eb,#7c3aed,#ec4899)",
            opacity:
              loading
                ? 0.7
                : 1
          }}
        >
          {loading
            ? "Submitting..."
            : "Apply For Approval"}
        </button>
		
		
		<div
  style={{
    background: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: 16,
    marginBottom: 20,
    fontSize: 14,
    color: "#374151"
  }}
>

  <strong>
    Contributor Guidelines
  </strong>

  <ul
    style={{
      marginBottom: 0
    }}
  >
    <li>
      Upload only your own content
    </li>

    <li>
      Educational content only
    </li>

    <li>
      Drawings, worksheets,
      charts and activities
      are encouraged
    </li>

    <li>
      Content will be reviewed
      before publishing
    </li>
  </ul>

</div>

      </div>

    </div>

  );

}